import React from "react";
import { styled } from "../stitches.config";
import { h1, h2, p } from "../redesign/commonStyles/Fonts";

const Calculator = React.lazy(() => import('./FertilityCalc'));
// import Calculator from "./FertilityCalc"
import Footer from "../redesign/components/Footer"


const CalculatorPage = () => {

    return (
        <>
            <Wrap>
                <h1 className={h1()}>Kalkulator dni płodnych - kiedy masz największe szanse na zajście w ciążę? Sprawdź!</h1>
                <p className={p()}><span>Kalkulator dni płodnych</span> lub <span>kalendarz dni płodnych</span> służy do wyliczenia, kiedy masz dni płodne i niepłodne. Dni płodne to czas, kiedy szanse na zajście w ciążę są największe.</p>
                <br />
                <h2 className={h2()}>Skorzystaj z naszego kalkulatora dni płodnych!</h2>
                <p className={p()}>Wystarczy, że podasz datę pierwszego dnia swojego cyklu (pierwszy dzień ostatniej miesiączki) oraz średnią długość trwania cyklu.</p>
                <p className={p()}>Kalendarz/kalkulator dni płodnych - pokaże ci, kiedy masz największe szanse zajść w ciążę (jak obliczyć <span>dni płodne</span>).</p>
                <p className={p()}>Jeżeli zaś chcesz uniknąć ciąży - kalkulator dni płodnych wskaże także twoje dni niepłodne. Pamiętaj, że kalkulator dni płodnych nie powinien być stosowany jako jedyna metoda zapobiegania ciąży!</p>

                <Calculator />

                <h2 className={h2()}>Kalkulator dni płodnych - kiedy są dni płodne?</h2>
                <p className={p()}>Kalkulator dni płodnych, czyli kalendarz dni płodnych pozwoli ci na wyznaczenie na podstawie długości cyklu menstruacyjnego dogodnego momentu na poczęcie dziecka. Aby to zrobić, musimy określić dzień owulacji, czyli jajeczkowania. Bez względu na długość cyklu, <span>owulacja</span> wypada zwykle ok. 14 dni przed miesiączką i jest to czas najbardziej płodny. To moment, w którym dojrzała komórka jajowa przedostaje się do jajowodu. Przeżywa po uwolnieniu z jajnika jedynie od 24 do 48 godzin.
                    <br />
                    Nieco mniejsze szanse na zajście w ciążę masz w czasie poprzedzającym owulację.
                </p>

                <h2 className={h2()}>Kalkulator dni płodnych a ciąża</h2>
                <p className={p()}>Lekarze podkreślają, że pary, które korzystają w wyliczenia, kiedy są dni płodne i świadomie podejmują wówczas współżycie, mają większe szanse na zajście w ciążę niż te, którym przez brak wyliczeń, zdarza się przegapić fazę płodną.</p>
                <p className={p()}>Pamiętaj jednak, że kalkulator dni płodnych określa twoje dni płodne, ale do zajścia w ciążę może dojść nie tylko w te dni! W trakcie ich trwania szanse na zajście w ciążę są największe. Zdarza się jednak, że do zapłodnienia dochodzi mimo stosunku odbytego w czasie dni niepłodnych. Dzieje się tak, gdyż plemniki są w stanie przetrwać w ciele kobiety nawet do tygodnia.</p>

                <h2 className={h2()}>Kalendarz dni płodnych - jak wyliczyć dni płodne i niepłodne?</h2>
                <p className={p()}>Żeby dokładniej obliczyć dni płodne, warto przyjrzeć się na fazom cyklu oraz samej owulacji.
                    <br />
                    Kalendarz owulacji - twój cykl zaczyna się od pierwszego dnia krwawienia, a kończy dzień przed następną miesiączką. Najczęściej cykl kobiety wynosi 28 dni. W przypadku gdy jest regularny, znacznie łatwiej wyznaczyć dni największej płodności.
                </p>
                <p className={p()}>Cykl owulacyjny możemy podzielić na fazę niepłodności względnej, fazę płodną oraz fazę niepłodności bezwzględnej.</p>

                <h2 className={h2()}>Faza niepłodności względnej</h2>
                <p className={p()}>To od niej zaczyna się twój cykl wraz z pojawieniem się krwawienia. Faza niepłodności względnej obejmuje czas krwawienia miesiączkowego i dojrzewania komórki jajowej. Jeśli twój cykl trwa 28 dni lub dłużej to jest dla ciebie <span>faza bezpłodna</span>. Jednak jeśli twój cykl jest krótszy (np. 25-dniowy), uważaj, bo w ostatnich dniach tej fazy mogą już być dni płodne.</p>

                <h2 className={h2()}>Faza płodna</h2>
                <p className={p()}>Faza płodna to owulacja, czyli jajeczkowanie oraz dni okołoowulacyjne. Obejmuje ona ok. 2-3 dni przed owulacją oraz minimum 1 dzień po jej zakończeniu. Komórka jajowa zostaje uwolniona do jajowodu i żyje 24 godziny. To twoje <span>dni największej płodności</span>. Jeśli w tym czasie komórka jajowa nie zostanie zapłodniona, zaczyna obumierać. Pamiętaj, że każdy organizm jest inny i z uwagi na indywidualne cechy dolicza się kilka dni okołoowulacyjnych jako <span>dni płodne</span>.</p>

                <h2 className={h2()}>Jakie są objawy dni płodnych?</h2>
                <p className={p()}>Większość z nas nie wie, że ma akurat dni płodne. Jeśli jednak zaczniesz bacznie obserwować swój cykl, prawdopodobnie zauważysz, że w trakcie dni płodnych pojawią się następujące objawy:</p>

                <ul>
                    <li className={p()}>rzadki, przezroczysty śluz przypominający białko z jaja kurzego,</li>
                    <li className={p()}>ból w dolnej części brzucha,</li>
                    <li className={p()}>tkliwość piersi,</li>
                    <li className={p()}>wzrost libido.</li>
                </ul>

                <h2 className={h2()}>Faza niepłodności bezwzględnej</h2>
                <p className={p()}>Faza niepłodności bezwzględnej trwa ok. 14 dni. W jej trakcie teoretycznie nie może dojść do zapłodnienia, ponieważ komórka jajowa obumarła.
                    <br />
                    Pamiętaj jednak, że jeśli do współżycia doszło w czasie dni niepłodnych, plemniki mogą dotrwać w twoim organizmie do dni płodnych.
                </p>

                <p className={p()}>Ważne! Kalkulator dni płodnych pomoże ci określić, kiedy prawdopodobieństwo zajścia w ciążę jest największe i najmniejsze. Nie stosuj go jednak jako jedynej metody antykoncepcji!</p>
            </Wrap>
            <Footer />
        </>
    )
}

export default CalculatorPage

const Wrap = styled('div', {
    margin: 'auto',
    padding: '10px 20px',
    'h1, h2, p, li': {
        color: '$grayscale100',
        fontFamily: '$grotesk',
    },
    '@bp4': {
        width: '60vw',
        padding: '20px 0px',
    }
})